// ==============================|| PRESET THEME - DEFAULT ||============================== //
import { THEME_COLOR_CONFIG } from 'config/themeColors';

export default function ThemeOption(colors, presetKey = 'blue') {
  const { grey } = colors;
  const primaryHue = typeof presetKey === 'string' && colors[presetKey] ? presetKey : 'blue';
  const primarySource = colors[primaryHue] || colors.blue;
  const errorSource = colors[THEME_COLOR_CONFIG.paletteMap.error] || colors.red;
  const warningSource = colors[THEME_COLOR_CONFIG.paletteMap.warning] || colors.gold;
  const infoSource = colors[THEME_COLOR_CONFIG.paletteMap.info] || colors.cyan;
  const successSource = colors[THEME_COLOR_CONFIG.paletteMap.success] || colors.green;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = THEME_COLOR_CONFIG.contrastText;

  return {
    primary: {
      lighter: primarySource[0],
      100: primarySource[1],
      200: primarySource[2],
      light: primarySource[3],
      400: primarySource[4],
      main: primarySource[5],
      dark: primarySource[6],
      700: primarySource[7],
      darker: primarySource[8],
      900: primarySource[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: errorSource[0],
      light: errorSource[2],
      main: errorSource[4],
      dark: errorSource[7],
      darker: errorSource[9],
      contrastText
    },
    warning: {
      lighter: warningSource[0],
      light: warningSource[3],
      main: warningSource[5],
      dark: warningSource[7],
      darker: warningSource[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoSource[0],
      light: infoSource[3],
      main: infoSource[5],
      dark: infoSource[7],
      darker: infoSource[9],
      contrastText
    },
    success: {
      lighter: successSource[0],
      light: successSource[3],
      main: successSource[5],
      dark: successSource[7],
      darker: successSource[9],
      contrastText
    },
    grey: greyColors
  };
}
